import { render, staticRenderFns } from "./footerBlock.vue?vue&type=template&id=1d5a799c&scoped=true&"
import script from "./footerBlock.vue?vue&type=script&lang=js&"
export * from "./footerBlock.vue?vue&type=script&lang=js&"
import style0 from "./footerBlock.vue?vue&type=style&index=0&id=1d5a799c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5a799c",
  null
  
)

export default component.exports